import { Box, styled, Typography } from '@mui/material';

export const ScreenContainer = styled(Box)`
  display: inline-flex;
  flex-direction: column;
  padding: 10px 0;
  justify-content: left;
`;

export const ScreenName = styled(Typography)(
  ({ theme }) => `
    font-size: 16px;
    font-weight: 300;
    color: '${theme.palette.brand.black}';
    margin-top: 10px;
  `,
);
